import { Variety } from "../Models/Variety";
import * as ko from "knockout";

export class BenchmarkParameter {
    Year: number;
    Varieties: Variety[];
}